import { createContext, useContext } from 'react'

const AmountsContext = createContext(undefined)

const AmountsProvider = ({ children, value }: any) => {
  return <AmountsContext.Provider value={value}>{children}</AmountsContext.Provider>
}

const useAmountsContext = () => {
  const context = useContext(AmountsContext)
  if (!context) {
    throw new Error('useAmountsContext must be used within a AmountsProvider')
  }
  return context
}

export { AmountsProvider, useAmountsContext }
